import { render, staticRenderFns } from "./IssuesNewHub.vue?vue&type=template&id=79e7d72c&"
import script from "./IssuesNewHub.vue?vue&type=script&lang=js&"
export * from "./IssuesNewHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports